export default {
  container: {
    width: 'calc(33.333% - 12px)',
    margin: '6px'
  },
  holder: {
    position: 'relative',
    cursor: 'pointer',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    background: '#fff',
    borderRadius: '5px',
    border: '1px solid #ddd',
    width: '100%',
    paddingBottom: '56%',
    overflow: 'hidden',
    '&:hover': {
      '& $author': {
        opacity: '1'
      }
    }
  },
  author: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    background: 'rgba(0, 0, 0, 0.6)',
    fontSize: '12px',
    color: '#fff',
    padding: '3px 5px',
    opacity: '0',
    transition: 'opacity 0.3s ease-in'
  },
  authorLink: {
    color: '#fff',
    textDecoration: 'none',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}
